import { Controller } from "@hotwired/stimulus";

// Toggle all checkboxes in a list
export default class extends Controller {
  static targets = ["toggle", "item"];

  toggle(event) {
    const sourceToggle = event?.currentTarget || this.toggleTargets[0];
    const checked = sourceToggle?.checked || false;

    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = checked;
    });

    // Keep every toggle checkbox in sync when there is more than one.
    this.toggleTargets.forEach((toggle) => {
      if (toggle !== sourceToggle) {
        toggle.checked = checked;
      }
    });
  }
}
